export default class Utils {
    static $simpleDatePattern = /(\d{2}\/\d{2}\/\d{4})|(\d{4}-\d{2}-\d{2})/;

    static isEmpty(val) {
        if (val === null || val === '' || val === undefined) {
            return true;
        } else {
            return false;
        }
    }
    static isObjEmpty(obj) {
        return obj == null || Object.keys(obj).length == 0;
    }

    static buildSelectOptions(data = [], blankDefault = true, obj = false, keyAsVal = false) {
        const options = [];
        if (blankDefault) {
            options.push({ label: '', value: '' });
        }
        if (obj) {
            for (const optn in data) {
                let option = { label: optn, value: data[optn] };
                if (keyAsVal) {
                    option.label = data[optn];
                    option.value = optn;
                }
                options.push(option);
            }
        } else {
            for (const optn of data) {
                options.push({ label: optn, value: optn });
            }
        }
        return options;
    }

    static isTruthy(val = '') {
        if (val === true || val === 'true') {
            return true;
        } else {
            return false;
        }
    }

    static formatDate(dateObj) { // takes Javascript Date object
        let date = dateObj.getDate().toString().padStart(2, '0')
        let month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
        const year = dateObj.getFullYear().toString();

        return year + '-' + month + '-' + date
    }

    static compareArrays(arr1, arr2) {
        if (arr1.length !== arr2.length) {
            return false;
        }
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }
        return true;
    }

    static replaceStr(str, strvar, strval) {
        let _str = str;
        if (!Utils.isEmpty(str) && !Utils.isEmpty(strvar) && !Utils.isEmpty(strval))
            _str = str.split(strvar).join(strval);
        return _str;
    }

}